export var SocketError;
(function (SocketError) {
    SocketError["notConnect"] = "Signalr is null, please doOpen";
})(SocketError || (SocketError = {}));
